module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc12-96d5e9eaebcc41429622ef62e7e68674.jpg";